export default [
	{
		value: '0',
		name: 'Bez dětí',
	},
	{
		value: '1',
		name: 'Jedno dítě',
	},
	{
		value: '2',
		name: 'Dvě děti',
	},
	{
		value: '3',
		name: 'Tři až čtyři děti',
	},
	{
		value: '4',
		name: 'Pět a více dětí',
	},
];
